import React from 'react';

import Platform from '@lyearn/core/utils/Platform';
import { HeaderState } from '@/components/EditorViewer/hooks/types';
import { useArticle } from '@/modules/corporate/modules/article/articleContext';

import MainContent from './MainContent';

const MainContentContainer: React.FC = () => {
  const { articleContent } = useArticle();

  const [headerState, setHeaderState] = React.useState<HeaderState>(
    Platform.select({
      native: HeaderState.Standard,
      web: articleContent.cover.src ? HeaderState.Transparent : HeaderState.Standard,
    }),
  );

  return <MainContent headerState={headerState} setHeaderState={setHeaderState} />;
};

export default React.memo(MainContentContainer);
